<template>
<div class="contentWidth head clearfix">
  <a href="" class="fleft logo">
    <img src="@/assets/images/dongmamilogo.png" width="98" height="130" />
  </a>
  <ul class="fleft menu clearfix">
    <li v-bind:class="{active:name=='main'}">
      <router-link to="/">首页</router-link>
    </li>
    <li v-bind:class="{active:aboutMenu}">
      <a href="javascript:;">关于我们</a>
      <span class="angle"></span>
      <div class="subMenu">
        <router-link to="aboutUS">董妈咪 </router-link>
        <router-link to="groupIntroduction">集团介绍 </router-link>
      </div>
    </li>
    <li v-bind:class="{active:name=='cooperation'}"><router-link to="cooperation">合作招募 </router-link></li>
    <li v-bind:class="{active:name=='products' || name=='productDetail'}"><router-link to="products">产品资源 </router-link></li>
    <li v-bind:class="{active:joinUs}">
      <a href="javascript:;">加入我们</a>
      <span class="angle"></span>
      <div class="subMenu">
        <router-link to="manager">市场经理 </router-link>
        <router-link to="recruit">日常招聘 </router-link>
      </div>
    </li>
  </ul>
  <div class="fright">
    <div class="tel">029-8758 1996</div>
    <div class="mail">service@yycunluo.com</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'commonHead',
  data () {
    return {
      name: '',
      joinUs: false,
      aboutMenu: false
    }
  },
  created () {
    this.name = this.$route.name
    if (this.name === 'manager' || this.name === 'recruit') {
      this.joinUs = true
    }
    if (this.name === 'aboutUs' || this.name === 'groupIntroduction') {
      this.aboutMenu = true
    }
  },
  watch: {
    $route (to) {
      this.name = to.name
      if (this.name === 'manager' || this.name === 'recruit') {
        this.joinUs = true
      } else {
        this.joinUs = false
      }

      if (this.name === 'aboutUs' || this.name === 'groupIntroduction') {
        this.aboutMenu = true
      } else {
        this.aboutMenu = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.head{
  height:70px;
  line-height: 70px;
  .logo{
    position: relative;
    width: 98px;
    height: 70px;
    z-index:100;
    img{
      position: absolute;
      left: 0;
      top:0;
      vertical-align: top;
    }
  }
  .menu{
    margin-left: 140px;
     li{
       float: left;
       position: relative;
       z-index:100;
       font-size: 16px;
       &.active{
         &>a{
           color: #fff;
           background-color: #f95374;
          }
         .angle{border-top:4px solid #fff;}
       }
       &:hover{
         &>a{
           color: #fff;
           background-color: #f95374;
          }
         .subMenu{display: block;z-index: 11;
          }
         .angle{border-top:4px solid #fff;}
       }
        a{
          width: 124px;
          display: block;
          text-align: center;
        }
        .angle{
          position: absolute;
          top:34px;
          right:16px;
          border: 4px solid transparent;
          border-top:4px solid #333;
        }
        .subMenu{
          display: none;
          position: absolute;
          left: 0;
          top:70px;
          background-color: #fff;
          padding: 15px 0;
          a{
            line-height: 40px;
            color: #999;
            font-size: 16px;
            &:hover{
              color: #f95374;
            };
          }
        }
      }
    }
  .tel{
    background: url(../assets/images/xingzhuang12.png) left center no-repeat;
    background-size: 28px 28px;
    padding-left: 32px;
    color: #f95374;
    font-weight: bold;
    font-size: 16px;
    height: 32px;
    line-height: 32px;
  }
  .mail{
    background: url(../assets/images/xingzhuang2.png) left center no-repeat;
    background-size: 28px 28px;
    padding-left: 32px;
    color: #f95374;
    font-weight: bold;
    font-size: 16px;
    height: 32px;
    line-height: 32px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commonHead.vue